// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 活码列表
import Qrcode from '@/views/huoma/Qrcode';
// 子码列表
import Child from '@/views/huoma/Child';
// 新增活码
import addQrcode from '@/views/huoma/addQrcode';
// 编辑活码
import editQrcode from '@/views/huoma/editQrcode';
// 超级外链
import linkList from '@/views/weike/linklist';
// 超级子码
import linkChild from '@/views/weike/child';
// 修改密码
import editPass from '@/views/huoma/editPass';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 域名管理
 */
// 域名管理
import Yuming from '@/views/yuming/Yuming';
/**
 * 一物一码
 */
// 分类管理
import Category from '@/views/yima/Category';
//一物一码列表
import Huoma from '@/views/yima/Huoma';
/**
 * 帮助和通知
 */
// 帮助
import help from '@/views/help/help';
//通知
import tongzhi from '@/views/help/tongzhi';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/huoma/addQrcode',
            name: '新增活码',
            component: addQrcode,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/huoma/Qrcode',
            name: '活码列表',
            component: Qrcode,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/weike/linklist',
            name: '超级外链',
            component: linkList,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/weike/child',
            name: '超级子码',
            component: linkChild,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/huoma/Child',
            name: '子码列表',
            component: Child,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/huoma/editQrcode',
            name: '编辑活码',
            component: editQrcode,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/yuming/Yuming',
            name: '域名管理',
            component: Yuming,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/yima/Category',
            name: '分类管理',
            component: Category,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/yima/Huoma',
            name: '一物一码',
            component: Huoma,
            meta: {
                requireAuth: true
            }
        },{
            path: '/help/help',
            name: '帮助文档',
            component: help,
            meta: {
                requireAuth: true
            }
        },{
            path: '/help/tongzhi',
            name: '服务通知',
            component: tongzhi,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/huoma/editPass',
            name: '修改密码',
            component: editPass,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '统计分析',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js